import { render, staticRenderFns } from "./SmsSendPointCreate.vue?vue&type=template&id=0e5bf58f&scoped=true"
import script from "./SmsSendPointCreate.vue?vue&type=script&lang=js"
export * from "./SmsSendPointCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5bf58f",
  null
  
)

export default component.exports